/* Generated by tools/build-localization.mjs. Do not edit by hand. */
import en from "./en";
import ru from "./ru";
import el from "./el";

export const resources = {
  en: { translation: en },
  ru: { translation: ru },
  el: { translation: el },
} as const;

export type Locale = keyof typeof resources;
export const locales: Locale[] = ["en", "ru", "el"];
